/**
 * The faces shipped in `public/fonts`. GENERATED by scripts/fetch-fonts.py —
 * do not hand-edit; add the family to that script and re-run it.
 *
 * Generated rather than hand-kept so a family cannot end up declared in
 * fonts.css with no entry in the picker, or offered in the picker with no
 * file behind it.
 */

export interface BundledFont {
  id: string;
  label: string;
  category: 'sans' | 'serif' | 'mono' | 'display';
  note?: string;
}

export const BUNDLED_FONTS: BundledFont[] = [
  {
    "id": "inter",
    "label": "Inter",
    "category": "sans",
    "note": "Clean and neutral. The default."
  },
  {
    "id": "noto",
    "label": "Noto Sans",
    "category": "sans",
    "note": "Built to cover every script evenly."
  },
  {
    "id": "atkinson",
    "label": "Atkinson Hyperlegible",
    "category": "sans",
    "note": "Letters shaped to be told apart. Easier on tired eyes."
  },
  {
    "id": "literata",
    "label": "Literata",
    "category": "serif",
    "note": "A serif made for reading. Kinder on long passages."
  },
  {
    "id": "jetbrains",
    "label": "JetBrains Mono",
    "category": "mono",
    "note": "Fixed width. Every character gets the same space."
  },
  {
    "id": "roboto",
    "label": "Roboto",
    "category": "sans"
  },
  {
    "id": "opensans",
    "label": "Open Sans",
    "category": "sans"
  },
  {
    "id": "lato",
    "label": "Lato",
    "category": "sans"
  },
  {
    "id": "montserrat",
    "label": "Montserrat",
    "category": "sans"
  },
  {
    "id": "poppins",
    "label": "Poppins",
    "category": "sans"
  },
  {
    "id": "raleway",
    "label": "Raleway",
    "category": "sans"
  },
  {
    "id": "nunito",
    "label": "Nunito",
    "category": "sans"
  },
  {
    "id": "worksans",
    "label": "Work Sans",
    "category": "sans"
  },
  {
    "id": "rubik",
    "label": "Rubik",
    "category": "sans"
  },
  {
    "id": "dmsans",
    "label": "DM Sans",
    "category": "sans"
  },
  {
    "id": "manrope",
    "label": "Manrope",
    "category": "sans"
  },
  {
    "id": "mulish",
    "label": "Mulish",
    "category": "sans"
  },
  {
    "id": "karla",
    "label": "Karla",
    "category": "sans"
  },
  {
    "id": "barlow",
    "label": "Barlow",
    "category": "sans"
  },
  {
    "id": "oswald",
    "label": "Oswald",
    "category": "sans"
  },
  {
    "id": "sourcesans",
    "label": "Source Sans 3",
    "category": "sans"
  },
  {
    "id": "plexsans",
    "label": "IBM Plex Sans",
    "category": "sans"
  },
  {
    "id": "figtree",
    "label": "Figtree",
    "category": "sans"
  },
  {
    "id": "outfit",
    "label": "Outfit",
    "category": "sans"
  },
  {
    "id": "quicksand",
    "label": "Quicksand",
    "category": "sans"
  },
  {
    "id": "publicsans",
    "label": "Public Sans",
    "category": "sans"
  },
  {
    "id": "ptsans",
    "label": "PT Sans",
    "category": "sans"
  },
  {
    "id": "firasans",
    "label": "Fira Sans",
    "category": "sans"
  },
  {
    "id": "merriweather",
    "label": "Merriweather",
    "category": "serif"
  },
  {
    "id": "playfair",
    "label": "Playfair Display",
    "category": "serif"
  },
  {
    "id": "lora",
    "label": "Lora",
    "category": "serif"
  },
  {
    "id": "ptserif",
    "label": "PT Serif",
    "category": "serif"
  },
  {
    "id": "librebaskerville",
    "label": "Libre Baskerville",
    "category": "serif"
  },
  {
    "id": "crimson",
    "label": "Crimson Text",
    "category": "serif"
  },
  {
    "id": "bitter",
    "label": "Bitter",
    "category": "serif"
  },
  {
    "id": "cormorant",
    "label": "Cormorant Garamond",
    "category": "serif"
  },
  {
    "id": "ebgaramond",
    "label": "EB Garamond",
    "category": "serif"
  },
  {
    "id": "sourceserif",
    "label": "Source Serif 4",
    "category": "serif"
  },
  {
    "id": "notoserif",
    "label": "Noto Serif",
    "category": "serif"
  },
  {
    "id": "robotoslab",
    "label": "Roboto Slab",
    "category": "serif"
  },
  {
    "id": "sourcecode",
    "label": "Source Code Pro",
    "category": "mono"
  },
  {
    "id": "robotomono",
    "label": "Roboto Mono",
    "category": "mono"
  },
  {
    "id": "plexmono",
    "label": "IBM Plex Mono",
    "category": "mono"
  },
  {
    "id": "firacode",
    "label": "Fira Code",
    "category": "mono"
  },
  {
    "id": "spacemono",
    "label": "Space Mono",
    "category": "mono"
  },
  {
    "id": "inconsolata",
    "label": "Inconsolata",
    "category": "mono"
  },
  {
    "id": "bebas",
    "label": "Bebas Neue",
    "category": "display"
  },
  {
    "id": "caveat",
    "label": "Caveat",
    "category": "display"
  },
  {
    "id": "pacifico",
    "label": "Pacifico",
    "category": "display"
  },
  {
    "id": "dancing",
    "label": "Dancing Script",
    "category": "display"
  },
  {
    "id": "lobster",
    "label": "Lobster",
    "category": "display"
  },
  {
    "id": "comfortaa",
    "label": "Comfortaa",
    "category": "display"
  }
] as BundledFont[];
